import React from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";

// Public Pages
import HomePage from "./pages/HomePage";
import ExpertStaffPage from "./pages/ExpertStaffPage";
import TherapistInfoPage from "./pages/TherapistInfoPage";
import SignIn from "./pages/signIn/SignIn";
import SignUp from "./pages/signUp/SignUp";
import VerificationCode from "./pages/signUp/VerificationCode";
import QuestionInfoPage from "./pages/questionPages/QuestionInfoPage";
import { QuestionPage } from "./pages/questionPages/QuestionPage";
import SignInTherapist from "./pages/signIn/SignInTherapist";
import SignUpTherapist from "./pages/signUp/SignUpTherapist";
import EmailVerificationPage from "./components/Verification/EmailVerification";
import TherapistEmailVerificationPage from "./components/Verification/TherapistEmailVerification";
import PaymentSuccessPage from "./pages/payment/PaymentSuccessPage";
import PaymentCanceledPage from "./pages/payment/PaymentCanceledPage";
import BlogPage from "./pages/BlogPage/BlogPage";
import BlogDetailPage from "./pages/BlogDetailPage/BlogDetailPage";
import OAuthSuccess from "./components/OAuth/OAuthSuccess";
import FAQ from "./pages/FAQPage/FAQPage";

// User Pages
import UserHomePage from "./pages/UserPage/UserHomePage";
import UserPageDiscoverPage from "./pages/UserPage/UserPageDiscoverPage";

import UserTherapyPlannerPage from "./pages/UserPage/UserTherapyPlannerPage";

import UserEditPage from "./pages/UserPage/UserEditPage";
import UserSettingsPage from "./pages/UserPage/UserSettingsPage";
import MyWalletPage from "./pages/UserPage/MyWalletPage";
import UserSupportPage from "./pages/UserPage/SupportPage";
import UserForgotPasswordPage from "./pages/UserPage/UserForgotPasswordPage";
import UserMessagesPage from "./pages/UserPage/UserMessagesPage";

// Therapist Pages
import TherapistHomePage from "./pages/TherapistPage/TherapistHomePage";
import TherapistTherapyPlannerPage from "./pages/TherapistPage/TherapistTherapyPlanner";
import TherapistPayment from "./pages/TherapistPage/TherapistPayment";
import TherapistEditpage from "./pages/TherapistPage/TherapistEditpage";
import TherapistSettingsPage from "./pages/TherapistPage/TherapistSettingPage";
import TherapistProfilePage from "./pages/TherapistPage/TherapistProfilePage";
import TherapistSupportPage from "./pages/TherapistPage/TherapistSuppotPage";
import TherapistMessagesPage from "./pages/TherapistPage/TherapistMessagesPage";
import TherapistClientReportsPage from "./pages/TherapistPage/TherapistClientReportsPage";
import StripeAccountSuccessPage from "./pages/TherapistPage/StripeAccountSuccessPage";
import StripeAccountRefreshPage from "./pages/TherapistPage/StripeAccountRefreshPage";

// Admin Pages
import AdminHomePage from "./pages/AdminPage/AdminHomePage";
import AdminTherapistInfoPage from "./pages/AdminPage/AdminTherapistInfoPage";
import AdminTherapistDetailPage from "./pages/AdminPage/AdminTherapistDetailsPage";
import AdminPaymentPage from "./pages/AdminPage/AdminPaymentPage";
import AdminSettingsPage from "./pages/AdminPage/AdminSettingsPage";
import AdminBlogPage from "./pages/AdminPage/AdminBlogPage";

// Other Components
import TherapyPlanner from "./components/UserTherapyPlanner/TherapyPlanner";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import TherapistForgotPassword from "./components/TherapistForgotPassword/ThearpistForgotPassword"
import AdminTestsHome from "./pages/AdminPage/AdminTestsHome"
import AdminTestsDetails from "./pages/AdminPage/AdminTestsDetailsPage"
import TestSolvePage from "./pages/TestPage/TestSolvePage"
import AboutUsPage from "./pages/AboutUsPage/AboutUsPage";
import AdminSupportPage from "./pages/AdminSupportPage/AdminSupportPage"
import AdminSurveysHome from "./pages/AdminPage/AdminSurveysHome"
import AdminSessionsPage from "./pages/AdminPage/AdminSessionsPage"
import AdminCouponsPage from "./pages/AdminPage/AdminCouponsPage"
import TherapyLandingPage from "./pages/LandingPages/TherapyLandingPage"

const AppRoute = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public Routes - Herkes erişebilir */}
        <Route path="/" element={<HomePage />} />
        <Route path="/how-does-it-work" element={<HomePage />} />
        <Route path="/therapistInfo/:id" element={<TherapistInfoPage />} />
        <Route path="/experts" element={<ExpertStaffPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogDetailPage />} />
        <Route path="/faq" element={<FAQ />} />
        
        {/* Auth Routes - Giriş yapmamış kişiler için */}
        <Route 
          path="/signIn" 
          element={
            <ProtectedRoute requireAuth={false}>
              <SignIn />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/signInTherapist" 
          element={
            <ProtectedRoute requireAuth={false}>
              <SignInTherapist />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/signUp" 
          element={
            <ProtectedRoute requireAuth={false}>
              <SignUp />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/signUpTherapist" 
          element={
            <ProtectedRoute requireAuth={false}>
              <SignUpTherapist />
            </ProtectedRoute>
          } 
        />
        <Route path="/verificationCode" element={<VerificationCode />} />
        <Route path="/verify/:userId/:token" element={<EmailVerificationPage />} />
        <Route path="/therapists/verify/:userId/:token" element={<TherapistEmailVerificationPage />} />
        <Route path="/reset-password/:id/:token" element={<UserForgotPasswordPage />} />
        
        {/* Question Routes - Auth gerektiren ama role önemli değil */}
        <Route 
          path="/questionInfo" 
          element={
            <ProtectedRoute requireAuth={true}>
              <QuestionInfoPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/questions/:id" 
          element={
            <ProtectedRoute requireAuth={true}>
              <QuestionPage />
            </ProtectedRoute>
          } 
        />

        {/* User Routes - Sadece user type'ı */}
        <Route 
          path="/userHomePage" 
          element={
            <ProtectedRoute allowedTypes={['user']} requireAuth={true}>
              <UserHomePage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/userPageDiscover" 
          element={
            <ProtectedRoute allowedTypes={['user']} requireAuth={true}>
              <UserPageDiscoverPage />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/userPageSupport" 
          element={
            <ProtectedRoute allowedTypes={['user']} requireAuth={true}>
              <UserSupportPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/userSettings" 
          element={
            <ProtectedRoute allowedTypes={['user']} requireAuth={true}>
              <UserSettingsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/myWallet" 
          element={
            <ProtectedRoute allowedTypes={['user']} requireAuth={true}>
              <MyWalletPage />
            </ProtectedRoute>
          } 
        />
        <Route
          path="/userTherapyPlanner"
          element={
            <ProtectedRoute allowedTypes={['user']} requireAuth={true}>
              <UserTherapyPlannerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/userPageMessage"
          element={
            <ProtectedRoute allowedTypes={['user']} requireAuth={true}>
              <UserMessagesPage />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/userEdit" 
          element={
            <ProtectedRoute allowedTypes={['user']} requireAuth={true}>
              <UserEditPage />
            </ProtectedRoute>
          } 
        />
        <Route  
          path="/test-solve" 
          element={
            <ProtectedRoute allowedTypes={['user']} requireAuth={true}>
              <TestSolvePage />
            </ProtectedRoute>
          } 
        />
        {/* Therapist Routes - Sadece therapist type'ı */}
        <Route 
          path="/therapistHomePage" 
          element={
            <ProtectedRoute allowedTypes={['therapist']} requireAuth={true}>
              <TherapistHomePage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/therapistProfileSettings" 
          element={
            <ProtectedRoute allowedTypes={['therapist']} requireAuth={true}>
              <TherapistProfilePage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/therapistTherapyPlanner" 
          element={
            <ProtectedRoute allowedTypes={['therapist']} requireAuth={true}>
              <TherapistTherapyPlannerPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/therapistPayment" 
          element={
            <ProtectedRoute allowedTypes={['therapist']} requireAuth={true}>
              <TherapistPayment />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/therapistEdit" 
          element={
            <ProtectedRoute allowedTypes={['therapist']} requireAuth={true}>
              <TherapistEditpage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/therapistSettings" 
          element={
            <ProtectedRoute allowedTypes={['therapist']} requireAuth={true}>
              <TherapistSettingsPage />
            </ProtectedRoute>
          } 
        />
        <Route
          path="/therapistSupport"
          element={
            <ProtectedRoute allowedTypes={['therapist']} requireAuth={true}>
              <TherapistSupportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/therapistClientReports"
          element={
            <ProtectedRoute allowedTypes={['therapist']} requireAuth={true}>
              <TherapistClientReportsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/therapistMessages"
          element={
            <ProtectedRoute allowedTypes={['therapist']} requireAuth={true}>
              <TherapistMessagesPage />
            </ProtectedRoute>
          }
        />

        <Route 
          path="/reset-password-therapist/:id/:token" 
          element={
              <TherapistForgotPassword />
          } 
        />

        <Route 
          path="/therapist/stripe/success" 
          element={
              <StripeAccountSuccessPage />
          } 
        />

        <Route 
          path="/therapist/stripe/refresh" 
          element={
              <StripeAccountRefreshPage />
          } 
        />

        {/* Admin Routes - Sadece admin type'ı */}
        <Route 
          path="/adminHome" 
          element={
            <ProtectedRoute allowedTypes={['admin']} requireAuth={true}>
              <AdminHomePage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/adminTherapistInfo" 
          element={
            <ProtectedRoute allowedTypes={['admin']} requireAuth={true}>
              <AdminTherapistInfoPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/adminTherapistDetail/:id" 
          element={
            <ProtectedRoute allowedTypes={['admin']} requireAuth={true}>
              <AdminTherapistDetailPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/adminSurveys"
          element={
            <ProtectedRoute allowedTypes={['admin']} requireAuth={true}>
              <AdminSurveysHome />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/adminTests"
          element={
            <ProtectedRoute allowedTypes={['admin']} requireAuth={true}>
              <AdminTestsHome />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/adminTests/:testId"
          element={
            <ProtectedRoute allowedTypes={['admin']} requireAuth={true}>
              <AdminTestsDetails  />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/adminPayment" 
          element={
            <ProtectedRoute allowedTypes={['admin']} requireAuth={true}>
              <AdminPaymentPage />
            </ProtectedRoute>
          } 
        />
        <Route
          path="/adminSessions"
          element={
            <ProtectedRoute allowedTypes={['admin']} requireAuth={true}>
              <AdminSessionsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/adminCoupons"
          element={
            <ProtectedRoute allowedTypes={['admin']} requireAuth={true}>
              <AdminCouponsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/adminSettings"
          element={
            <ProtectedRoute allowedTypes={['admin']} requireAuth={true}>
              <AdminSettingsPage />
            </ProtectedRoute>
          }
        />
        <Route path="/adminSupports" element={
          <ProtectedRoute allowedTypes={['admin']} requireAuth={true}>
            <AdminSupportPage />
          </ProtectedRoute>
        }
        />
        <Route
          path="/adminBlog"
          element={
            <ProtectedRoute allowedTypes={['admin']} requireAuth={true}>
              <AdminBlogPage />
            </ProtectedRoute>
          }
        />

        {/* Shared Components */}
        <Route 
          path="/therapyPlanner" 
          element={
            <ProtectedRoute requireAuth={true}>
              <TherapyPlanner />
            </ProtectedRoute>
          } 
        />

        {/* OAuth ve Payment Routes */}
        <Route path="/auth/success" element={<OAuthSuccess />} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/canceled" element={<PaymentCanceledPage />} />

        {/* Legacy Route - Eski therapistInfo route'u */}
        <Route path="/therapistInfo" element={<TherapistInfoPage />} />
        <Route path="/aboutUs" element={<AboutUsPage />} />
        <Route path="/therapy/:slug" element={<TherapyLandingPage />} />
      </Routes>
    </>
  );
};

export default AppRoute;
